/** @typedef {import('../routeSchema').RouteNode} RouteNode */

/** @type {RouteNode[]} */
const paymentRoutes = [
  {
    type: "route",
    id: "payment-checkout",
    name: "Payment Checkout",
    path: "/payment-checkout",
    component: "PaymentPage",
  },
  {
    type: "route",
    id: "payment-success",
    name: "Payment Successful",
    path: "/payment-successfull",
    component: "PaymentSuccessfull",
  },
  {
    type: "route",
    id: "payment-cancelled",
    name: "Payment Cancelled",
    path: "/payment-cancelled",
    component: "PaymentCancelled",
  },
];

export default paymentRoutes;
